var _path, _flowRegion, _flowPara, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilePptx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.692 1c-2.288 0-3.204.177-4.15.683a4.452 4.452 0 0 0-1.859 1.858C1.177 4.488 1 5.404 1 7.691v30.617c0 2.288.177 3.204.683 4.15a4.452 4.452 0 0 0 1.858 1.859c.947.506 1.863.683 4.15.683h20.617c2.288 0 3.204-.177 4.15-.683a4.452 4.452 0 0 0 1.859-1.858c.506-.947.683-1.863.683-4.15V14.501c0-1.387-.04-1.902-.168-2.456a4.224 4.224 0 0 0-.552-1.332c-.302-.482-.638-.874-1.62-1.854l-5.538-5.528c-.98-.979-1.373-1.314-1.854-1.615a4.224 4.224 0 0 0-1.33-.55C23.387 1.04 22.872 1 21.487 1H7.692z",
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#E1E1E3",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("flowRoot", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    letterSpacing: "0px",
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _flowRegion || (_flowRegion = /*#__PURE__*/React.createElement("flowRegion", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.678,
    y: 8.9661,
    width: 34.695,
    height: 42.492
  }))), _flowPara || (_flowPara = /*#__PURE__*/React.createElement("flowPara", null, "PP"))), /*#__PURE__*/React.createElement("text", {
    x: 9.1994038,
    y: 33.772133,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "26.702px",
    letterSpacing: "0px",
    strokeWidth: 0.66756,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    transform: "matrix(.60632 0 0 .60632 3.6385 3.7904)",
    x: 9.1994038,
    y: 33.772133,
    fill: "#dc4c2c",
    fontFamily: "FreeSans",
    fontWeight: 600,
    strokeWidth: 0.66756
  }, "P"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePptx);
export default __webpack_public_path__ + "static/media/file-pptx.b47344e99fc0d263fa0bdb0cd6b0b9a8.svg";
export { ForwardRef as ReactComponent };